module.exports = __webpack_public_path__ + "static/media/Airplane_main_t.73790c3e.jpg";